// src/components/studentPortal/AlumniNetwork.jsx
// Section 4 of the Student Portal. UI SHELL ONLY - static mock data below,
// no backend. The composer is visually functional (local state) but does
// not post anywhere. Flagged, not started: whether blog_type + the existing
// blog table could back "article" posts is a real question for later, not
// attempted tonight given the time budget.
import React, { useState } from 'react';
import { FiImage, FiFileText, FiHeart, FiMessageSquare, FiShare2, FiSend } from 'react-icons/fi';

const MOCK_POSTS = [
  {
    id: 1, type: 'photo', author: 'Aisha Rahman', institute: 'Delhi Film School',
    time: '2h ago', content: 'On set for our final-year short - golden hour magic today.',
    likes: 24, comments: 5,
  },
  {
    id: 2, type: 'article', author: 'Rohan Mehta', institute: 'Mumbai Media Academy',
    time: '1d ago', content: '5 lessons I learned editing my first documentary',
    excerpt: 'Editing taught me more about storytelling than any lecture could...',
    likes: 41, comments: 12,
  },
  {
    id: 3, type: 'photo', author: 'Priya Nair', institute: 'Chennai Institute of Film',
    time: '2d ago', content: 'Wrapped principal photography on our thesis film!',
    likes: 63, comments: 18,
  },
];

const Avatar = ({ name }) => (
  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
    {name.charAt(0)}
  </div>
);

const PostCard = ({ post }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4">
    <div className="flex items-center gap-3 mb-3">
      <Avatar name={post.author} />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-800 truncate">{post.author}</p>
        <p className="text-xs text-slate-400 truncate">{post.institute} · {post.time}</p>
      </div>
    </div>

    {post.type === 'article' ? (
      <div className="rounded-xl border border-slate-100 bg-slate-50 p-4 mb-3">
        <p className="text-sm font-semibold text-slate-800 mb-1">{post.content}</p>
        <p className="text-xs text-slate-500">{post.excerpt}</p>
      </div>
    ) : (
      <>
        <p className="text-sm text-slate-700 mb-3">{post.content}</p>
        <div className="h-40 rounded-xl bg-gradient-to-br from-teal-100 to-cyan-100 flex items-center justify-center text-teal-400 mb-3">
          <FiImage size={28} />
        </div>
      </>
    )}

    <div className="flex items-center gap-5 text-xs text-slate-500 pt-1">
      <button className="flex items-center gap-1.5 hover:text-teal-600 transition-colors duration-150">
        <FiHeart size={14} /> {post.likes}
      </button>
      <button className="flex items-center gap-1.5 hover:text-teal-600 transition-colors duration-150">
        <FiMessageSquare size={14} /> {post.comments}
      </button>
      <button className="flex items-center gap-1.5 hover:text-teal-600 transition-colors duration-150">
        <FiShare2 size={14} /> Share
      </button>
    </div>
  </div>
);

const AlumniNetwork = () => {
  const [draft, setDraft] = useState('');

  return (
    <div>
      <h2 className="text-xl font-bold text-slate-800 mb-4">Alumni Network</h2>

      <div className="rounded-2xl border border-slate-200 bg-white p-4 mb-6">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Share an update with your alumni network..."
          rows={2}
          className="w-full text-sm outline-none resize-none placeholder-slate-400"
        />
        <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-100">
          <div className="flex gap-3 text-slate-400">
            <button className="flex items-center gap-1.5 text-xs font-medium hover:text-teal-600 transition-colors duration-150">
              <FiImage size={14} /> Photo
            </button>
            <button className="flex items-center gap-1.5 text-xs font-medium hover:text-teal-600 transition-colors duration-150">
              <FiFileText size={14} /> Article
            </button>
          </div>
          <button
            disabled={!draft.trim()}
            className="flex items-center gap-1.5 text-xs font-semibold text-white bg-teal-600 hover:bg-teal-700 disabled:opacity-40 rounded-full px-4 py-1.5 transition-colors duration-150"
          >
            <FiSend size={12} /> Post
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {MOCK_POSTS.map((post) => <PostCard key={post.id} post={post} />)}
      </div>
    </div>
  );
};

export default AlumniNetwork;
